module.exports = __webpack_public_path__ + "img/logo_versions@2x.9c8da68f.png";